import { render, staticRenderFns } from "./FinderFrameElement.vue?vue&type=template&id=12a85e1e"
import script from "./FinderFrameElement.vue?vue&type=script&lang=js"
export * from "./FinderFrameElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports